import React, { useState, useMemo, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { handleGetRequest } from '../../utils/api-handler.util'
import SubscriptionPlanCard from './SubscriptionPlanCard'
import { useAuth } from '../../contexts/AuthContext'

const SubscriptionPlanList = ({ onGetStarted }) => {
  const { currentUser } = useAuth()
  const [middleIndex, setMiddleIndex] = useState(0)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [activePlanIndex, setActivePlanIndex] = useState(1)

  const currentPlanId = currentUser?.activeSubscription?.subscription?.id

  const { data: plansData } = useQuery({
    queryKey: QueryKeys.subscriptionPlans(),
    queryFn: () => handleGetRequest('/subscription-tiers'),
  })

  const plans = useMemo(() => plansData?.data || [], [plansData])

  useEffect(() => {
    if (plans.length > 0 && !selectedPlan) {
      const middle = Math.floor(plans.length / 2)
      setActivePlanIndex(middle)
      setSelectedPlan(plans[middle])
      setMiddleIndex(middle)
    }
  }, [plans, selectedPlan])

  const handleToggleChange = (index) => {
    setActivePlanIndex(index)
    setSelectedPlan(plans[index])
  }

  return (
    <div className="w-full flex flex-col items-center">
      <div className="mb-12">
        <div className="flex items-center bg-background rounded-full p-1 shadow-lg border border-gray-200">
          {plans.map((plan, index) => (
            <button
              key={plan.id}
              onClick={() => handleToggleChange(index)}
              className={`relative px-6 py-3 rounded-full font-medium text-sm transition-all duration-300 ${
                activePlanIndex === index
                  ? 'bg-gradient-to-r from-secondary-700 to-secondary-700 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              {plan.name}
            </button>
          ))}
        </div>
      </div>

      {selectedPlan && (
        <div className="w-full max-w-lg">
          <SubscriptionPlanCard
            plan={selectedPlan}
            selected={true}
            onSelect={() => {}}
            highlighted={activePlanIndex === middleIndex}
            onGetStarted={() => onGetStarted(selectedPlan)}
            isToggleView={true}
            isCurrentPlan={selectedPlan.id === currentPlanId}
          />
        </div>
      )}
    </div>
  )
}

export default SubscriptionPlanList
